import { SCShareCount } from './SCShareCount';

export class Xing extends SCShareCount {
	public name = 'xing';
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/socialmedia/services/Xing.ts